import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { AppTextField } from '@vyce/core/src/components/inputs';

import { QualificationFields } from '../types';

interface Props {
  name: keyof QualificationFields;
  label: string;
}

export const ReviewField = ({ name, label }: Props) => {
  const { control } = useFormContext<QualificationFields>();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => <AppTextField {...field} label={label} margin="none" fullWidth />}
    />
  );
};
